exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".categories__option__2GZ1t,.categories__options__35IOB{width:100%}.categories__option__2GZ1t{display:block;overflow:hidden;text-overflow:ellipsis}", "", {"version":3,"sources":["/home/builduser/agent43/work/c8e02a04a4ed599f/src/widget/components/categories/src/widget/components/categories/categories.styl","/home/builduser/agent43/work/c8e02a04a4ed599f/src/widget/components/categories/categories.styl"],"names":[],"mappings":"AAGA,uDAFE,UAAA,CAEF,2BACE,cAAA,gBAEA,sBACA,CCCD","file":"categories.styl","sourcesContent":[".options\n  width 100%\n\n.option\n  display block\n  width 100%\n  overflow hidden\n  text-overflow ellipsis\n",".options {\n  width: 100%;\n}\n.option {\n  display: block;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/*# sourceMappingURL=src/widget/components/categories/categories.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"option": "categories__option__2GZ1t",
	"options": "categories__options__35IOB"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/categories/categories.styl
// module id = 2544
// module chunks = 1